import './registerServiceWorker'

import config, { DO_NOT_LOGIN } from 'config'
import { runWithAdal } from 'react-adal'

import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import { authContext } from './adalConfig'

if (config.environment !== 'development') {
  Sentry.init({
    dsn: config.sentryUrl,
    integrations: [new Integrations.BrowserTracing()],
    release: `utargi-web@${config.version}#${config.build}`,
    tracesSampleRate: config.tracesSampleRate,
  })
}

// Note: Postpone App injection because ServiceWorker has to be initialized first. Otherwise, it would not cache initial requests
// Note: This is temporary solution, the best would be to wait until SW is registered and then start App
setTimeout(() => {
  // eslint-disable-next-line
  runWithAdal(authContext, () => require('./appIndex.tsx'), DO_NOT_LOGIN)
}, 200)
